import React from 'react';
import { Provider } from 'react-redux';
import { generateStore } from '../../redux/store';
import VtexJsonToHefesto from './VtexJsonToHefesto';

const HefestoToJsonWrapper = () => {
	const store = React.useMemo(() => generateStore(), []);
	return (
		<Provider store={store}>
			<VtexJsonToHefesto />
		</Provider>
	);
};

export default HefestoToJsonWrapper;
